// Global JavaScript for Shopify theme

// Hero Slider functionality
document.addEventListener('DOMContentLoaded', function() {
  const heroSliders = document.querySelectorAll('.hero-slider');
  
  heroSliders.forEach(slider => {
    const slides = slider.querySelectorAll('.hero-slide');
    const indicators = slider.querySelectorAll('.indicator-dot');
    const autoplay = slider.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed) || 5000;
    let currentSlide = 0;
    let autoplayInterval = null;
    
    if (slides.length === 0) return;
    
    // Initialize first slide as active if none is active
    const hasActiveSlide = Array.from(slides).some(slide => slide.classList.contains('active'));
    if (!hasActiveSlide && slides.length > 0) {
      slides[0].classList.add('active');
      if (indicators.length > 0) {
        indicators[0].classList.add('active');
      }
      currentSlide = 0;
    } else {
      // Find the active slide index
      slides.forEach((slide, index) => {
        if (slide.classList.contains('active')) {
          currentSlide = index;
        }
      });
    }
    
    // Function to set background image based on screen size
    function setResponsiveBackgroundImage(slide) {
      const isMobile = window.innerWidth <= 768;
      const desktopImage = slide.getAttribute('data-bg-image');
      const mobileImage = slide.getAttribute('data-bg-image-mobile');
      
      // Use mobile image if available and on mobile, otherwise use desktop image
      const bgImage = (isMobile && mobileImage) ? mobileImage : desktopImage;
      
      if (bgImage) {
        slide.style.setProperty('--bg-image', `url('${bgImage}')`);
      } else {
        // Fallback background color if no image
        slide.style.setProperty('--bg-image', 'none');
        slide.style.backgroundColor = '#f5f5f5';
      }
    }
    
    // Set background images for slides
    function updateAllSlideBackgrounds() {
      slides.forEach(slide => {
        setResponsiveBackgroundImage(slide);
      });
    }
    
    // Initialize backgrounds
    updateAllSlideBackgrounds();
    
    // Update backgrounds on resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateAllSlideBackgrounds, 150);
    });
    
    // Function to show a specific slide
    function showSlide(index) {
      if (index < 0 || index >= slides.length) return;
      
      // Remove active class from all slides and indicators
      slides.forEach(slide => slide.classList.remove('active'));
      indicators.forEach(indicator => indicator.classList.remove('active'));
      
      // Add active class to current slide and indicator
      if (slides[index]) {
        slides[index].classList.add('active');
      }
      if (indicators[index]) {
        indicators[index].classList.add('active');
      }
      
      currentSlide = index;
    }
    
    // Function to go to next slide
    function nextSlide() {
      const nextIndex = (currentSlide + 1) % slides.length;
      showSlide(nextIndex);
    }
    
    // Function to go to previous slide
    function prevSlide() {
      const prevIndex = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(prevIndex);
    }
    
    // Add click handlers to indicators
    indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showSlide(index);
        resetAutoplay();
        return false;
      });
    });
    
    // Autoplay functionality
    function startAutoplay() {
      if (autoplay && slides.length > 1) {
        autoplayInterval = setInterval(nextSlide, autoplaySpeed);
      }
    }
    
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }
    
    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }
    
    // Pause autoplay on hover
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    
    // Start autoplay
    startAutoplay();
    
    // Keyboard navigation
    slider.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') {
        prevSlide();
        resetAutoplay();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
        resetAutoplay();
      }
    });
    
    // Make slider focusable for keyboard navigation
    slider.setAttribute('tabindex', '0');
  });
});

// Cart functionality
if (!window.cart) {
  window.cart = {};
}

window.cart.addItem = function(variantId, quantity = 1) {
  return fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.status === 422) {
      throw new Error(data.description || window.cartStrings.error);
    }
    return data;
  })
  .catch(error => {
    console.error('Error adding item to cart:', error);
    throw error;
  });
};

// Search functionality
document.addEventListener('DOMContentLoaded', function() {
  // Handle search form submission
  const searchForm = document.querySelector('.search-form');
  if (searchForm) {
    searchForm.addEventListener('submit', function(e) {
      const input = this.querySelector('.search-input');
      if (!input.value.trim()) {
        e.preventDefault();
      }
    });
  }
  
  // Bestsellers category tabs functionality
  const bestsellersSection = document.querySelector('.bestsellers-section');
  if (bestsellersSection) {
    const categoryTabs = bestsellersSection.querySelectorAll('.category-tab');
    const categoryBadges = bestsellersSection.querySelectorAll('.category-badge');
    const productCards = bestsellersSection.querySelectorAll('.product-card');
    const exploreMoreCards = bestsellersSection.querySelectorAll('.explore-more-card');
    
    // Function to switch category
    function switchCategory(category, activeTab) {
      // Update active tab
      categoryTabs.forEach(t => t.classList.remove('active'));
      if (activeTab) {
        activeTab.classList.add('active');
      }
      
      // Show/hide category badge with smooth transition
      let badgeFound = false;
      categoryBadges.forEach(badge => {
        if (badge.dataset.category === category) {
          badge.classList.remove('hidden');
          badge.style.display = 'block';
          badge.style.opacity = '0';
          // Trigger reflow for transition
          badge.offsetHeight;
          badge.style.opacity = '1';
          badgeFound = true;
        } else {
          badge.style.opacity = '0';
          setTimeout(() => {
            badge.classList.add('hidden');
            badge.style.display = 'none';
          }, 200);
        }
      });
      
      // If no badge found for this category, show first badge as fallback
      if (!badgeFound && categoryBadges.length > 0) {
        const firstBadge = categoryBadges[0];
        firstBadge.classList.remove('hidden');
        firstBadge.style.display = 'block';
        firstBadge.style.opacity = '1';
      }
      
      // Show/hide explore more card based on category
      exploreMoreCards.forEach(card => {
        if (card.dataset.category === category) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      });
      
      // Show/hide products based on category
      let hasVisibleProducts = false;
      productCards.forEach(card => {
        const cardCategory = card.dataset.category;
        if (cardCategory === category || category === 'all' || !cardCategory) {
          card.style.display = 'flex';
          card.style.visibility = 'visible';
          hasVisibleProducts = true;
        } else {
          card.style.display = 'none';
          card.style.visibility = 'hidden';
        }
      });
      
      // If no products match, show all products as fallback
      if (!hasVisibleProducts && productCards.length > 0) {
        productCards.forEach(card => {
          card.style.display = 'flex';
          card.style.visibility = 'visible';
        });
        hasVisibleProducts = true;
      }
      
      // Show empty message if no products for this category
      const productsGrid = bestsellersSection.querySelector('.products-grid');
      let emptyMessage = productsGrid.querySelector('.bestsellers-empty-category');
      if (!hasVisibleProducts && !emptyMessage) {
        emptyMessage = document.createElement('div');
        emptyMessage.className = 'bestsellers-empty-category';
        emptyMessage.innerHTML = '<p>No products available for this category.</p>';
        productsGrid.appendChild(emptyMessage);
      } else if (hasVisibleProducts && emptyMessage) {
        emptyMessage.remove();
      }
    }
    
    // Initialize: Show badge for first active tab
    const activeTab = bestsellersSection.querySelector('.category-tab.active');
    const controlsContainer = bestsellersSection.querySelector('.bestsellers-controls');
    
    // Reset scroll to show first tab on mobile
    if (controlsContainer && window.innerWidth <= 768) {
      controlsContainer.scrollLeft = 0;
    }
    
    if (activeTab) {
      const initialCategory = activeTab.dataset.category;
      switchCategory(initialCategory, activeTab);
    } else if (categoryTabs.length > 0) {
      // If no active tab, activate first one
      categoryTabs[0].classList.add('active');
      switchCategory(categoryTabs[0].dataset.category, categoryTabs[0]);
    }
    
    // Add click handlers to tabs
    categoryTabs.forEach(tab => {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const category = this.dataset.category;
        switchCategory(category, this);
        
        // Scroll active tab into view on mobile (only scrolls the tab container, not the page)
        if (window.innerWidth <= 768) {
          const controlsContainer = bestsellersSection.querySelector('.bestsellers-controls');
          if (controlsContainer) {
            const tabRect = this.getBoundingClientRect();
            const containerRect = controlsContainer.getBoundingClientRect();
            const scrollLeft = controlsContainer.scrollLeft;
            const tabOffset = this.offsetLeft - controlsContainer.offsetLeft;
            const tabCenter = tabOffset + (this.offsetWidth / 2) - (controlsContainer.offsetWidth / 2);
            
            controlsContainer.scrollTo({
              left: scrollLeft + tabCenter,
              behavior: 'smooth'
            });
          }
        }
        return false;
      });
    });
  }
  
  // Product card add to cart
  const productCardForms = document.querySelectorAll('.product-card form');
  productCardForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(this);
      const variantId = formData.get('id');
      
      if (variantId) {
        window.cart.addItem(variantId, 1)
          .then(() => {
            // Update cart count
            fetch(window.routes.cart_url + '.js')
              .then(response => response.json())
              .then(cart => {
                const cartCount = document.querySelector('.cart-count');
                if (cartCount) {
                  cartCount.textContent = cart.item_count > 0 ? cart.item_count : '';
                }
              });
            
            // Show success message (you can customize this)
            alert('Product added to cart!');
          })
          .catch(error => {
            alert(error.message || 'Error adding product to cart');
          });
      }
    });
  });
});

// Utility functions
window.utils = {
  debounce: function(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },
  
  formatMoney: function(cents, format) {
    if (typeof cents === 'string') {
      cents = parseInt(cents, 10);
    }
    
    const value = cents / 100;
    const formatString = format || '{{amount}}';
    
    return formatString.replace('{{amount}}', value.toFixed(2));
  }
};

// Testimonials Carousel functionality
document.addEventListener('DOMContentLoaded', function() {
  const carouselWrappers = document.querySelectorAll('.testimonials-carousel-wrapper');
  
  carouselWrappers.forEach(wrapper => {
    const carousel = wrapper.querySelector('.testimonials-carousel');
    const track = wrapper.querySelector('.testimonials-track');
    const prevBtn = wrapper.querySelector('.testimonials-nav-prev');
    const nextBtn = wrapper.querySelector('.testimonials-nav-next');
    const cards = track.querySelectorAll('.testimonial-card');
    
    if (!carousel || !track || !prevBtn || !nextBtn || cards.length === 0) return;
    
    let currentIndex = 0;
    
    // Get card dimensions dynamically
    function getCardDimensions() {
      if (cards.length === 0) return { width: 450, gap: 48 };
      const firstCard = cards[0];
      const cardRect = firstCard.getBoundingClientRect();
      const cardWidth = cardRect.width;
      
      // Get gap from computed styles
      const trackStyles = window.getComputedStyle(track);
      const gap = parseInt(trackStyles.gap) || 48;
      
      return { width: cardWidth, gap: gap };
    }
    
    // Center a card at the given index
    function centerCard(index) {
      if (index < 0 || index >= cards.length) return;
      
      const { width: cardWidth, gap } = getCardDimensions();
      const carouselWidth = carousel.offsetWidth;
      const trackWidth = track.scrollWidth;
      
      // Calculate the position of the card's left edge in the track
      const cardPosition = index * (cardWidth + gap);
      
      // Calculate the center position in the carousel viewport
      const centerPosition = (carouselWidth - cardWidth) / 2;
      
      // Calculate the translateX needed to center the card
      let translateX = centerPosition - cardPosition;
      
      // Handle edge cases - don't scroll past the beginning
      const maxTranslateX = 0;
      if (translateX > maxTranslateX) {
        translateX = maxTranslateX;
      }
      
      // Handle edge cases - don't scroll past the end
      const minTranslateX = carouselWidth - trackWidth;
      if (translateX < minTranslateX) {
        translateX = minTranslateX;
      }
      
      track.style.transform = `translateX(${translateX}px)`;
      
      // Update button states
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index >= cards.length - 1;
    }
    
    function nextSlide() {
      if (currentIndex < cards.length - 1) {
        currentIndex++;
        centerCard(currentIndex);
      }
    }
    
    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        centerCard(currentIndex);
      }
    }
    
    // Event listeners
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      nextSlide();
      return false;
    });
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      prevSlide();
      return false;
    });
    
    // Initialize - center first card
    centerCard(0);
    
    // Update on resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (currentIndex >= cards.length) {
          currentIndex = cards.length - 1;
        }
        centerCard(currentIndex);
      }, 250);
    });
  });
  
  // Video Reviews Carousel
  const videoReviewsSection = document.querySelector('.video-reviews-section');
  if (videoReviewsSection) {
    const carousel = videoReviewsSection.querySelector('.video-reviews-carousel');
    const track = videoReviewsSection.querySelector('.video-reviews-track');
    const indicators = videoReviewsSection.querySelectorAll('.video-review-indicator');
    const cards = videoReviewsSection.querySelectorAll('.video-review-card');
    const prevBtn = videoReviewsSection.querySelector('.video-reviews-nav-prev');
    const nextBtn = videoReviewsSection.querySelector('.video-reviews-nav-next');
    
    if (carousel && track && indicators.length > 0 && cards.length > 0) {
      let currentIndex = 0;
      let visibleCards = 3;
      let useNativeScroll = false;
      let scrollDebounce;
      let ignoreScrollEvent = false;
      
      const setIndicatorState = (activeIndex) => {
        indicators.forEach((indicator, index) => {
          indicator.classList.toggle('active', index === activeIndex);
        });
      };
      
      const scrollToCard = (card, behavior = 'smooth') => {
        if (!card) return;
        const trackStyles = window.getComputedStyle(track);
        const paddingLeft = parseInt(trackStyles.paddingLeft) || 0;
        const targetOffset = Math.max(0, card.offsetLeft - paddingLeft);
        
        if (typeof carousel.scrollTo === 'function') {
          carousel.scrollTo({
            left: targetOffset,
            behavior
          });
        } else {
          carousel.scrollLeft = targetOffset;
        }
      };
      
      function calculateVisibleCards() {
        const carouselWidth = carousel.offsetWidth;
        if (carouselWidth <= 768) {
          visibleCards = 1;
          useNativeScroll = true;
        } else if (carouselWidth < 1200) {
          visibleCards = 2;
          useNativeScroll = false;
        } else {
          visibleCards = 3;
          useNativeScroll = false;
        }
      }
      
      function updateCarousel() {
        if (cards.length === 0) return;
        
        if (useNativeScroll) {
          track.style.transform = 'translateX(0)';
          if (prevBtn && nextBtn) {
            prevBtn.disabled = true;
            nextBtn.disabled = true;
          }
          
          setIndicatorState(currentIndex);
          
          return;
        }
        
        const cardWidth = cards[0].offsetWidth;
        const cardStyle = window.getComputedStyle(track);
        const gap = parseInt(cardStyle.gap) || 56;
        
        // Simple offset calculation - no centering adjustment needed
        // since container is max-width: 1468px (exactly 3 cards + gaps)
        const slideOffset = currentIndex * (cardWidth + gap);
        
        // Apply transform - negative for sliding left
        track.style.transform = `translateX(-${slideOffset}px)`;
        
        // Update indicator states
        setIndicatorState(currentIndex);
        
        // Update button states
        if (prevBtn && nextBtn) {
          // Allow navigation through all cards (0 to cards.length - 1)
          const maxIndex = cards.length - 1;
          prevBtn.disabled = currentIndex === 0;
          nextBtn.disabled = currentIndex >= maxIndex;
        }
      }
      
      function goToSlide(index) {
        const maxIndex = cards.length - 1;
        currentIndex = Math.min(Math.max(0, index), maxIndex);
        
        if (useNativeScroll) {
          ignoreScrollEvent = true;
          const targetCard = cards[currentIndex];
          scrollToCard(targetCard);
          setIndicatorState(currentIndex);
          
          // Re-enable scroll event after animation completes
          setTimeout(() => {
            ignoreScrollEvent = false;
          }, 500);
        } else {
          updateCarousel();
        }
      }
      
      // Indicator event listeners
      indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Disable scroll listener temporarily to prevent interference
          if (useNativeScroll) {
            clearTimeout(scrollDebounce);
          }
          
          goToSlide(index);
          return false;
        });
      });
      
      // Navigation button event listeners
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          goToSlide(currentIndex - 1);
          return false;
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          goToSlide(currentIndex + 1);
          return false;
        });
      }
      
      // Initialize
      calculateVisibleCards();
      updateCarousel();
      
      // Recalculate on window resize
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          const oldVisibleCards = visibleCards;
          calculateVisibleCards();
          if (oldVisibleCards !== visibleCards) {
            // Adjust current index if necessary
            const maxIndex = Math.max(0, cards.length - visibleCards);
            if (currentIndex > maxIndex) {
              currentIndex = maxIndex;
            }
          }
          
          if (useNativeScroll) {
            scrollToCard(cards[currentIndex], 'auto');
          } else {
            carousel.scrollLeft = 0;
          }
          
          updateCarousel();
        }, 250);
      });
      
      carousel.addEventListener('scroll', function() {
        if (!useNativeScroll || ignoreScrollEvent) return;
        clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(() => {
          if (ignoreScrollEvent) return;
          
          const viewportCenter = carousel.scrollLeft + (carousel.offsetWidth / 2);
          let closestIndex = 0;
          let minDistance = Infinity;
          
          cards.forEach((card, index) => {
            const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
            const distance = Math.abs(cardCenter - viewportCenter);
            if (distance < minDistance) {
              minDistance = distance;
              closestIndex = index;
            }
          });
          
          currentIndex = closestIndex;
          setIndicatorState(currentIndex);
        }, 100);
      });
    }
  }
  
  // Video Modal functionality
  // Use event delegation with capture phase to intercept clicks before any default behavior
  
  // Handle play button clicks with capture phase to prevent scroll
  document.addEventListener('click', function(e) {
    // Check if clicked on a play button FIRST (highest priority for video functionality)
    const playBtn = e.target.closest('.video-review-play-btn');
    if (playBtn) {
      // Immediately prevent all default behavior
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      if (playBtn.classList.contains('video-review-play-btn-disabled')) {
        return false;
      }
      
      const videoCard = playBtn.closest('.video-review-card');
      if (videoCard) {
        const instagramUrl = videoCard.getAttribute('data-instagram-url');
        const videoUrl = videoCard.getAttribute('data-video-url');
        if (instagramUrl && instagramUrl.trim() !== '') {
          openVideo(instagramUrl);
        } else {
          openVideo(videoUrl);
        }
      }
      return false;
    }
    
    // Check if clicked anywhere on a video card
    const videoCard = e.target.closest('.video-review-card-clickable');
    if (videoCard) {
      // Don't trigger if clicking on content text
      if (!e.target.closest('.video-review-content')) {
        e.preventDefault();
        e.stopPropagation();
        const instagramUrl = videoCard.getAttribute('data-instagram-url');
        const videoUrl = videoCard.getAttribute('data-video-url');
        if (instagramUrl && instagramUrl.trim() !== '') {
          openVideo(instagramUrl);
        } else {
          openVideo(videoUrl);
        }
      }
      return;
    }
    
    // Check if clicked on modal close button
    if (e.target.closest('.video-modal-close')) {
      e.preventDefault();
      e.stopPropagation();
      closeVideoModal();
      return;
    }
    
    // Check if clicked on modal overlay (outside content)
    const modalOverlay = e.target.closest('.video-modal-overlay');
    if (modalOverlay && e.target === modalOverlay) {
      e.preventDefault();
      closeVideoModal();
      return;
    }
  }, true); // Use capture phase
  
  // Close modal on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      const videoModal = document.getElementById('videoModal');
      if (videoModal && videoModal.classList.contains('active')) {
        closeVideoModal();
      }
    }
  });
  
  // Function to convert YouTube URL to embed URL
  function getYouTubeEmbedUrl(url) {
    if (!url) return '';
    
    let videoId = '';
    
    // Standard watch URL: https://www.youtube.com/watch?v=VIDEO_ID
    if (url.includes('youtube.com/watch')) {
      try {
        const urlParams = new URLSearchParams(new URL(url).search);
        videoId = urlParams.get('v');
      } catch (e) {
        console.error('Error parsing YouTube URL:', e);
      }
    }
    // Short URL: https://youtu.be/VIDEO_ID
    else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1].split('?')[0].split('&')[0];
    }
    // Already an embed URL
    else if (url.includes('youtube.com/embed/')) {
      return url;
    }
    // Vimeo URL
    else if (url.includes('vimeo.com/')) {
      const vimeoId = url.split('vimeo.com/')[1].split('?')[0];
      return `https://player.vimeo.com/video/${vimeoId}?autoplay=1`;
    }
    // Instagram Reel/Post URL
    else if (url.includes('instagram.com/reel/') || url.includes('instagram.com/p/')) {
      // Extract the reel/post ID path
      const match = url.match(/instagram\.com\/(reel|p)\/([^/?]+)/);
      if (match) {
        return `https://www.instagram.com/${match[1]}/${match[2]}/embed/`;
      }
      return url;
    }
    
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    }
    
    return url;
  }
  
  // Function to open video modal
  function openVideo(videoUrl) {
    const videoModal = document.getElementById('videoModal');
    const videoIframe = document.getElementById('videoIframe');
    
    if (!videoModal || !videoIframe) {
      console.error('Video modal elements not found');
      return;
    }
    
    // Check if video URL is provided
    if (!videoUrl || videoUrl.trim() === '') {
      console.warn('No video URL configured for this review');
      return;
    }
    
    // Move modal to documentElement (html) to avoid body transform/stacking issues
    if (videoModal.parentElement !== document.documentElement) {
      document.documentElement.appendChild(videoModal);
    }

    const embedUrl = getYouTubeEmbedUrl(videoUrl);
    videoIframe.src = embedUrl;
    videoModal.classList.add('active');

    // Switch modal to portrait for Instagram Reels
    const modalContent = document.getElementById('videoModalContent');
    if (modalContent) {
      if (videoUrl && (videoUrl.includes('instagram.com/reel/') || videoUrl.includes('instagram.com/p/'))) {
        modalContent.classList.add('video-modal-instagram');
      } else {
        modalContent.classList.remove('video-modal-instagram');
      }
    }

    // Prevent body scroll
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }
  
  // Function to close video modal
  function closeVideoModal() {
    const videoModal = document.getElementById('videoModal');
    const videoIframe = document.getElementById('videoIframe');
    
    if (!videoModal || !videoIframe) return;
    
    videoModal.classList.remove('active');
    videoIframe.src = '';
    
    // Restore body scroll
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
  
  // ============================================================================
  // Blog Posts Carousel
  // ============================================================================
  const blogPostsCarousel = document.querySelector('.blog-posts-carousel');
  if (blogPostsCarousel) {
    const track = blogPostsCarousel.querySelector('.blog-posts-track');
    const cards = blogPostsCarousel.querySelectorAll('.blog-post-card');
    const indicators = document.querySelectorAll('.blog-post-indicator');
    let currentIndex = 0;
    const isMobile = window.innerWidth <= 768;
    
    function isMobileView() {
      return window.innerWidth <= 768;
    }
    
    function scrollToCard(index) {
      if (!track || !cards[index]) return;
      
      const card = cards[index];
      const cardLeft = card.offsetLeft;
      const cardWidth = card.offsetWidth;
      const containerWidth = blogPostsCarousel.offsetWidth;
      const scrollLeft = cardLeft - (containerWidth / 2) + (cardWidth / 2);
      
      track.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
    
    function updateIndicators(index) {
      indicators.forEach((indicator, i) => {
        if (i === index) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });
    }
    
    function showPost(index) {
      if (isMobileView()) {
        // Mobile: Use native scrolling
        scrollToCard(index);
        updateIndicators(index);
        currentIndex = index;
      } else {
        // Desktop: Show/hide cards
        cards.forEach(card => {
          card.classList.remove('active');
        });
        
        if (cards[index]) {
          cards[index].classList.add('active');
        }
        
        updateIndicators(index);
        currentIndex = index;
      }
    }
    
    // Handle scroll events on mobile
    if (track && isMobileView()) {
      let scrollTimeout;
      track.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          // Find which card is most visible
          const containerRect = blogPostsCarousel.getBoundingClientRect();
          let closestIndex = 0;
          let closestDistance = Infinity;
          
          cards.forEach((card, index) => {
            const cardRect = card.getBoundingClientRect();
            const cardCenter = cardRect.left + (cardRect.width / 2);
            const containerCenter = containerRect.left + (containerRect.width / 2);
            const distance = Math.abs(cardCenter - containerCenter);
            
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          
          if (closestIndex !== currentIndex) {
            currentIndex = closestIndex;
            updateIndicators(closestIndex);
          }
        }, 100);
      });
    }
    
    // Indicator click events
    indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showPost(index);
        return false;
      });
    });
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (isMobileView()) {
          // On mobile, ensure all cards are visible
          cards.forEach(card => {
            card.classList.add('active');
          });
        } else {
          // On desktop, show only active card
          showPost(currentIndex);
        }
      }, 250);
    });
    
    // Initialize
    if (isMobileView()) {
      cards.forEach(card => {
        card.classList.add('active');
      });
    }
    showPost(0);
  }

  // Mobile Menu Toggle
  const menuToggle = document.querySelector('.header-menu-toggle');
  const headerNav = document.querySelector('.header-nav');
  let scrollPosition = 0;
  
  if (menuToggle && headerNav) {
    const closeMobileMenu = () => {
      headerNav.classList.remove('mobile-open');
      headerNav.classList.remove('submenu-open');
      menuToggle.classList.remove('active');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollPosition);
      headerNav.querySelectorAll('.nav-item').forEach(item => {
        item.classList.remove('active');
        const toggle = item.querySelector('.nav-dropdown-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
      // Clear submenu
      const submenuItems = headerNav.querySelector('.submenu-items');
      const submenuTitle = headerNav.querySelector('.submenu-title');
      if (submenuItems) submenuItems.innerHTML = '';
      if (submenuTitle) submenuTitle.textContent = '';
    };

    menuToggle.addEventListener('click', function() {
      const isOpen = headerNav.classList.contains('mobile-open');
      
      if (isOpen) {
        closeMobileMenu();
      } else {
        scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        document.body.style.top = `-${scrollPosition}px`;
        headerNav.classList.add('mobile-open');
        menuToggle.classList.add('active');
        menuToggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('menu-open');
      }
    });

    // Close menu when clicking outside
    document.addEventListener('click', function(event) {
      if (window.innerWidth <= 768) {
        if (!headerNav.contains(event.target) && !menuToggle.contains(event.target) && headerNav.classList.contains('mobile-open')) {
          closeMobileMenu();
        }
      }
    });

    // Handle sliding submenu on mobile
    const submenuTitle = headerNav.querySelector('.submenu-title');
    const submenuItems = headerNav.querySelector('.submenu-items');
    const submenuBack = headerNav.querySelector('.submenu-back');

    if (submenuTitle && submenuItems && submenuBack) {
      const navItems = headerNav.querySelectorAll('.nav-item-has-dropdown');
      
      const openSubmenu = (dropdown, parentTitle) => {
        const dropdownLinks = dropdown.querySelectorAll('.nav-dropdown-link');
        
        // Set submenu title
        submenuTitle.textContent = parentTitle;
        
        // Clear and populate submenu items
        submenuItems.innerHTML = '';
        dropdownLinks.forEach(link => {
          const clonedLink = link.cloneNode(true);
          submenuItems.appendChild(clonedLink);
        });
        
        // Show submenu
        headerNav.classList.add('submenu-open');
      };
      
      navItems.forEach(item => {
        const navLink = item.querySelector('.nav-link');
        const toggle = item.querySelector('.nav-dropdown-toggle');
        const dropdown = item.querySelector('.nav-dropdown');
        
        if (toggle && dropdown) {
          // Handle click on the entire nav link (prevent navigation on both mobile and desktop)
          if (navLink) {
            navLink.addEventListener('click', function(e) {
              e.preventDefault();
              
              if (window.innerWidth <= 768) {
                // Mobile: open sliding submenu
                const parentTitle = toggle.getAttribute('data-parent-title');
                openSubmenu(dropdown, parentTitle);
              } else {
                // Desktop: toggle dropdown visibility
                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
                toggle.setAttribute('aria-expanded', !isExpanded);
                item.setAttribute('aria-expanded', !isExpanded);
              }
            });
          }

          // Handle click on the toggle arrow
          toggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            if (window.innerWidth <= 768) {
              // Mobile: open sliding submenu
              const parentTitle = toggle.getAttribute('data-parent-title');
              openSubmenu(dropdown, parentTitle);
            }
          });
        }
      });

      // Handle back button
      submenuBack.addEventListener('click', function() {
        headerNav.classList.remove('submenu-open');
        // Clear submenu items after animation
        setTimeout(() => {
          submenuItems.innerHTML = '';
          submenuTitle.textContent = '';
        }, 300);
      });
    }

    const handleResize = () => {
      if (window.innerWidth > 768) {
        closeMobileMenu();
      }
    };

    window.addEventListener('resize', handleResize);
  }

  // Mobile Search Toggle
  const searchToggle = document.querySelector('.header-search-toggle');
  const headerSearch = document.querySelector('.header-search');
  
  if (searchToggle && headerSearch) {
    searchToggle.addEventListener('click', function() {
      const isOpen = headerSearch.classList.contains('mobile-open');
      
      if (isOpen) {
        headerSearch.classList.remove('mobile-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      } else {
        headerSearch.classList.add('mobile-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        // Focus the search input when opened
        const searchInput = headerSearch.querySelector('.search-input');
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 100);
        }
      }
    });

    // Close search when clicking outside on mobile
    document.addEventListener('click', function(event) {
      if (window.innerWidth <= 768) {
        if (!headerSearch.contains(event.target) && !searchToggle.contains(event.target)) {
          headerSearch.classList.remove('mobile-open');
          searchToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });

    // Close search on window resize to desktop
    const handleSearchResize = () => {
      if (window.innerWidth > 768) {
        headerSearch.classList.remove('mobile-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    };

    window.addEventListener('resize', handleSearchResize);
  }
});

// Footer Accordion functionality
document.addEventListener('DOMContentLoaded', function() {
  const footerNavColumns = document.querySelectorAll('.footer-nav-column');
  
  function initFooterAccordion() {
    const isMobile = window.innerWidth <= 768;
    
    footerNavColumns.forEach(column => {
      const toggle = column.querySelector('.footer-nav-toggle');
      const links = column.querySelector('.footer-nav-links');
      
      if (toggle && links) {
        // Set initial aria-expanded state based on screen size
        if (isMobile) {
          toggle.setAttribute('aria-expanded', 'false');
          column.setAttribute('aria-expanded', 'false');
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          column.setAttribute('aria-expanded', 'true');
        }
      }
    });
  }
  
  // Initialize on load
  initFooterAccordion();
  
  footerNavColumns.forEach(column => {
    const toggle = column.querySelector('.footer-nav-toggle');
    const links = column.querySelector('.footer-nav-links');
    
    if (toggle && links) {
      // Handle toggle click
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Only work on mobile
        if (window.innerWidth <= 768) {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          
          // Close all other columns (optional - can be removed if you want multiple open)
          footerNavColumns.forEach(col => {
            if (col !== column) {
              const otherToggle = col.querySelector('.footer-nav-toggle');
              if (otherToggle) {
                otherToggle.setAttribute('aria-expanded', 'false');
                col.setAttribute('aria-expanded', 'false');
              }
            }
          });
          
          // Toggle current column
          toggle.setAttribute('aria-expanded', !isExpanded);
          column.setAttribute('aria-expanded', !isExpanded);
        }
      });
    }
  });
  
  // Handle window resize to reset accordion state
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      initFooterAccordion();
    }, 250);
  });
});


// Sticky Header - CSS sticky handles positioning; JS toggles shadow class
(function() {
  function initStickyHeader() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyHeader);
      return;
    }

    const headerWrapper = document.querySelector('.header-section-wrapper');
    if (!headerWrapper) return;

    let ticking = false;
    let lastScrollY = 0;
    let isSticky = false;
    let isMenuOpen = false;

    function onScroll() {
      lastScrollY = window.scrollY;
      if (!ticking) {
        requestAnimationFrame(updateStickyClass);
        ticking = true;
      }
    }

    function updateStickyClass() {
      ticking = false;
      if (isMenuOpen) return;
      const shouldStick = lastScrollY > 2;
      if (shouldStick !== isSticky) {
        headerWrapper.classList.toggle('is-sticky', shouldStick);
        isSticky = shouldStick;
      }
    }

    function updateMobileMenuPosition(headerNav) {
      const header = headerWrapper.querySelector('.header');
      if (!header) return;
      const headerHeight = header.offsetHeight;
      headerNav.style.setProperty('top', headerHeight + 'px', 'important');
      headerNav.style.setProperty('height', 'calc(100vh - ' + headerHeight + 'px)', 'important');
      headerNav.style.setProperty('max-height', 'calc(100vh - ' + headerHeight + 'px)', 'important');
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Watch for mobile menu open/close
    const headerNav = document.querySelector('.header-nav');
    if (headerNav) {
      new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            const wasMenuOpen = isMenuOpen;
            isMenuOpen = headerNav.classList.contains('mobile-open');
            if (isMenuOpen && !wasMenuOpen) {
              document.body.style.overflow = 'hidden';
              updateMobileMenuPosition(headerNav);
            } else if (!isMenuOpen && wasMenuOpen) {
              document.body.style.overflow = '';
              headerNav.style.top = '';
              headerNav.style.height = '';
              headerNav.style.maxHeight = '';
              updateStickyClass();
            }
          }
        });
      }).observe(headerNav, { attributes: true });
    }

    updateStickyClass();
  }

  initStickyHeader();
})();


/* Wishlist Functionality */
window.WISHLIST_KEY = 'lofoodsWishlist';

window.getWishlist = function() {
  return JSON.parse(localStorage.getItem(window.WISHLIST_KEY)) || [];
}

window.saveWishlist = function(wishlist) {
  localStorage.setItem(window.WISHLIST_KEY, JSON.stringify(wishlist));
}

window.toggleWishlist = function(btn, handle) {
  if (window.event) {
    window.event.preventDefault();
    window.event.stopPropagation();
  }

  let wishlist = window.getWishlist();
  let index = -1;
  
  for(let i=0; i<wishlist.length; i++) {
    if(wishlist[i].handle === handle) {
      index = i;
      break;
    }
  }

  if (index === -1) {
    wishlist.push({ handle: handle, addedAt: Date.now() });
  } else {
    wishlist.splice(index, 1);
  }

  window.saveWishlist(wishlist);
  
  // Dispatch event for other scripts to listen
  const event = new CustomEvent('wishlist:updated', { detail: { handle: handle, isInWishlist: (index === -1) } });
  window.dispatchEvent(event);
  
  // Update all instances of this button on the page
  const buttons = document.querySelectorAll('.wishlist-btn[data-product-handle="' + handle + '"]');
  buttons.forEach(b => {
    if (index === -1) b.classList.add('active');
    else b.classList.remove('active');
  });
};

function initWishlistButtons() {
    const wishlist = window.getWishlist();
    if (!wishlist.length) return;
    
    wishlist.forEach(item => {
        const buttons = document.querySelectorAll('.wishlist-btn[data-product-handle="' + item.handle + '"]');
        buttons.forEach(btn => btn.classList.add('active'));
    });
}

document.addEventListener('DOMContentLoaded', initWishlistButtons);

document.addEventListener('DOMContentLoaded', initWishlistButtons);


/* Ensure wishlist:updated event is dispatched */
window.addEventListener('wishlist:updated', function(e) {
  console.log('Wishlist updated:', e.detail);
});
